;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:propstrata-app":true});}catch(e){}}();type VisualizationChartKeyParams = {
	viewName: string;
	visualizationName: string;
	workspaceId: string;
};

type VisualizationDataKeyParams = VisualizationChartKeyParams & {
	searchKey: string;
};

type VisualizationConfigKeyParams = {
	search: Record<string, string | number>;
	viewName: string;
	workspaceId: string;
};

type VisualizationGoalPostsKeyParams = {
	search: Record<string, string>;
	viewVisualizationId: string;
	workspaceId: string;
};

type VisualizationLeasingCardSummariesKeyParams = {
	filtersKey: string;
	workspaceId: string;
};

export const visualizationQueryKeys = {
	all: (workspaceId: string) => [workspaceId, "visualization"] as const,
	byName: ({
		searchKey,
		viewName,
		visualizationName,
		workspaceId,
	}: VisualizationDataKeyParams) =>
		[
			...visualizationQueryKeys.chart({
				viewName,
				visualizationName,
				workspaceId,
			}),
			searchKey,
		] as const,
	chart: ({
		viewName,
		visualizationName,
		workspaceId,
	}: VisualizationChartKeyParams) =>
		[
			...visualizationQueryKeys.view({ viewName, workspaceId }),
			visualizationName,
		] as const,
	config: ({ search, viewName, workspaceId }: VisualizationConfigKeyParams) =>
		[workspaceId, "workspace-visualizations-config", viewName, search] as const,
	drillDown: ({
		searchKey,
		viewName,
		visualizationName,
		workspaceId,
	}: VisualizationDataKeyParams) =>
		[
			...visualizationQueryKeys.chart({
				viewName,
				visualizationName,
				workspaceId,
			}),
			"drill-down",
			searchKey,
		] as const,
	goalPosts: ({
		search,
		viewVisualizationId,
		workspaceId,
	}: VisualizationGoalPostsKeyParams) =>
		["goal-posts", workspaceId, viewVisualizationId, search] as const,
	leasingCardSummaries: ({
		filtersKey,
		workspaceId,
	}: VisualizationLeasingCardSummariesKeyParams) =>
		[
			...visualizationQueryKeys.leasingCardSummariesPrefix(workspaceId),
			filtersKey,
		] as const,
	leasingCardSummariesPrefix: (workspaceId: string) =>
		[workspaceId, "leasing-card-summaries"] as const,
	view: ({
		viewName,
		workspaceId,
	}: {
		viewName: string;
		workspaceId: string;
	}) => [...visualizationQueryKeys.all(workspaceId), viewName] as const,
};

export const visualizationMutationKeys = {
	editViewConfig: ({
		viewName,
		workspaceId,
	}: {
		viewName: string;
		workspaceId: string;
	}) => ["edit-visualization-view-config", workspaceId, viewName] as const,
	goalPostsCreate: ({
		viewVisualizationId,
		workspaceId,
	}: {
		viewVisualizationId?: string;
		workspaceId: string;
	}) => ["goal-posts", workspaceId, viewVisualizationId, "create"] as const,
	goalPostsDelete: ({
		viewVisualizationId,
		workspaceId,
	}: {
		viewVisualizationId?: string;
		workspaceId: string;
	}) => ["goal-posts", workspaceId, viewVisualizationId, "delete"] as const,
	goalPostsUpdate: ({
		viewVisualizationId,
		workspaceId,
	}: {
		viewVisualizationId?: string;
		workspaceId: string;
	}) => ["goal-posts", workspaceId, viewVisualizationId, "update"] as const,
	sync: (workspaceId: string) =>
		["visualization", workspaceId, "sync"] as const,
	syncByName: ({
		visualizationName,
		workspaceId,
	}: {
		visualizationName: string;
		workspaceId: string;
	}) => ["visualization", workspaceId, visualizationName, "sync"] as const,
};
